var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 32 32",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x33_0"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_9"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_8"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_7"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_6"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_5"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_4"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_3"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_2"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_1"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_0"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_8"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_7"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_6"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_5"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_4"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_3"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_2"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_1"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_0"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "_x39_"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "_x38_"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "_x37_"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "_x36_"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "_x35_"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "_x34_"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "_x33_"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "_x32_"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "_x31_"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,3H10c-3.86,0-7,3.14-7,7v12c0,3.86,3.14,7,7,7h12c3.86,0,7-3.14,7-7V10C29,6.14,25.86,3,22,3z M27,22   c0,2.757-2.243,5-5,5H10c-2.757,0-5-2.243-5-5V10c0-2.757,2.243-5,5-5h12c2.757,0,5,2.243,5,5V22z M16,10c-3.309,0-6,2.691-6,6   s2.691,6,6,6s6-2.691,6-6S19.309,10,16,10z M16,20c-2.206,0-4-1.794-4-4s1.794-4,4-4s4,1.794,4,4S18.206,20,16,20z M24,9.5   c0,0.828-0.672,1.5-1.5,1.5S21,10.328,21,9.5S21.672,8,22.5,8S24,8.672,24,9.5z"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Guides"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.a4c4a54d817fbd7f0901ef1ed36d8f63.svg";
export { ForwardRef as ReactComponent };